import {BrowserRouter, Route, Routes} from 'react-router-dom'
import {Authentication} from './modules/authentication/Authentication'
import {Dashboard} from './modules/dashboard/Dashboard'
import {ConfirmModal} from 'components/confirm-modal/ConfirmModal'
import {Snackbar} from 'components/snackbar-toast/SnackBar'
import {AutoUpdate} from 'components/auto-update/AutoUpdate'

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/authentication/*" element={<Authentication />} />
          <Route path="*" element={<Dashboard />} />
        </Routes>
      </BrowserRouter>
      <ConfirmModal />
      <Snackbar />
      <AutoUpdate />
    </>
  )
}

export default App
